module.exports = __webpack_public_path__ + "static/thumb-aviation-api-6a92e6469596d47042b0ac7140ff3a96.png";